// NOTE: This file must remain a JS file because
// it's used in `vite.config.js`

export const VERSION = '3.5.1'
export const RELEASE_TIME = 1741430400000
